<div class="field-input-group-actions">
    <a class="btn btn-transparent btn-clear"
       (click)="changePassInputType()">
        <span [hidden]="showPassword" tooltip tooltip-title="Show">
            <img ycnImage [imageSrc]="'accounts/images/password-show.png'">
        </span>
        <span [hidden]="!showPassword" tooltip tooltip-title="Hide">
           <img ycnImage [imageSrc]="'accounts/images/password-no-show.png'">
        </span>
    </a>
</div>
